import React, {useEffect, useState} from 'react';
// import { useData } from '../../hooks/useData';

import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
const Breadcrumbs = dynamic(() => import("../../components/breadcrumbs"));
const Card = dynamic(() => import("../../components/card"));
import sanityClient from "../../../public/support-func/sanityClient";
import { sortByDate } from '../../../public/support-func/support.js';
import Head from 'next/head';
import {groq} from 'next-sanity';
// сделать подгрузку при скролле

export async function getStaticProps({params}) {
    const pageData = await sanityClient.fetch(`*[_type == "stories" && active == true ]`);
    const categoryQuery = groq`*[_type == "categories" && activeCategory == true  && slug.current == $slug]`;
    const category = await sanityClient.fetch( categoryQuery, { slug: params.slug });
  
    return {
      props: { 
        pageData,
        category: category[0]
      },
      revalidate: 60
    };
};

export const getStaticPaths = async () => {
    const categories = await sanityClient.fetch(`*[_type == "categories" && activeCategory == true] { slug }`);
    const paths = categories.map((category: any) => ({
        params: {
            slug: category.slug.current
        }
    }));

    return { 
        paths, 
        fallback: true
    };
};

const Category = ({pageData, category}) => {
    const router = useRouter();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])


    return (
        <>
            <Head>
            <title>{ category?.title }</title>
            <meta name="description" content={category?.shortDescription} />
            <meta name="keywords" content={category?.meta_keywords} />
            </Head>
            <Breadcrumbs pathArr={[{name: "Категории", url: "/categories",}, {name: category?.title}]} />
            <h1 className='accent_text'>{category?.title}</h1>
            <section className='section story_cards'>
                {sortByDate(pageData)?.filter((point: any) => point.category._ref === category?._id).map((item: any, i: number) => {
                    return <Card 
                                key={item._id}
                                title={item.title}
                                text={item.shortDescription}
                                linkToStory={`/stories/${item.slug.current}`}
                            />
                })}
            </section>
            
        </>
    )
}

export default Category;